  <div class="time-proposals-modal">
    <div class="modal-header">
      <h2 class="modal-title" *ngIf="currentStep === 1">Time proposals ({{currentStep}}/3)</h2>
      <h2 class="modal-title" *ngIf="currentStep === 2">Meeting details ({{currentStep}}/3)</h2>
      <h2 class="modal-title" *ngIf="currentStep === 3">Share and embed ({{currentStep}}/3)</h2>
      <button mat-icon-button class="close-button" (click)="closeModal()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  
    <div class="modal-content">
      <!-- Step 1: Time selection -->
      <div *ngIf="currentStep === 1" class="calendar-step">

        @if(type !== 'general'){
          <app-calendar 
          [meetingScheduler]="true" 
          [defaultView]="'week'" 
          [showCalendarMode]="true" 
          [hourSegments]="hourSegments" 
          [dayStartHour]="9" 
          [propasalTimes]="allScheduledMeetings"
          [defaultMeetingDuration]="meetingDuration"
          [dayEndHour]="23">
        </app-calendar>
        }
        @else{
          <app-general-meeting-scheduler [editMode]="editMode" [generalMeetingData]="generalMeetingData"></app-general-meeting-scheduler>
        }
       
        
      </div>
  
      <!-- Step 2: Meeting details -->
      <div *ngIf="currentStep === 2 && !isLoading">
        <app-meeting-details [meetingFormData]="meetingForm" [isAvailibility]="type === 'general'"></app-meeting-details>
        
      </div>
  
      <!-- Step 3: Share and embed -->
      <div *ngIf="currentStep === 3">
        <app-meeting-share [meetingId]="meetingId"></app-meeting-share>
      </div>
    </div>
  
    <div class="modal-footer">
      <div class="timezone-info">
        Times set in your current time zone - {{currentTimezone}} (UTC {{timezoneOffset}})
      </div>
      <div class="action-buttons">
        <button mat-stroked-button *ngIf="currentStep > 1" (click)="goBack()">Back</button>
        <button mat-stroked-button *ngIf="currentStep === 1" (click)="closeModal()">Cancel</button>
        <button mat-flat-button color="primary" *ngIf="currentStep === 1" [disabled]="hasSelectedTimes()" (click)="continueToDetails()">Continue to meeting details</button>
        <button mat-flat-button color="primary" *ngIf="currentStep === 2" (click)="continueToShare()">Continue</button>
        
        <!-- Modified Step 3 buttons -->
      <!-- Modified Step 3 buttons -->
<ng-container *ngIf="currentStep === 3">
  <!-- Only show the "Send as" button when there is a currentLead -->
  <button mat-stroked-button [matMenuTriggerFor]="sendMenu" *ngIf="currentLead">
    <mat-icon>send</mat-icon> Send as
  </button>
  <mat-menu #sendMenu="matMenu">
    <button mat-menu-item (click)="sendMeetingLink('email')">
      <mat-icon>email</mat-icon> Email
    </button>
    <button mat-menu-item (click)="sendMeetingLink('sms')">
      <mat-icon>sms</mat-icon> SMS
    </button>
  </mat-menu>
  <button mat-flat-button color="primary" (click)="finishSetup()">Done</button>
</ng-container>
      </div>
    </div>
  </div>